import React, { useState, useEffect } from "react";
import {
  Form,
  Upload,
  Radio,
  Cascader,
  Input,
  message,
  DatePicker,
  Button,
  Alert
} from "antd";
import { showMessage, baseUrl } from "utils";
import { getIndustry } from "apis/admin";
import {
  createCompanyIdentify,
  infoCompanyIdentify,
  updateCompanyIdentify,
  createCustomerIdentify,
  infoCustomerIdentify,
  updateCustomerIdentify
} from "apis/user";
import {
  LoadingOutlined,
  PlusOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import * as qs from "query-string";
import "../../index.css";
import "braft-editor/dist/index.css";
import moment from "moment";
import city from "components/city";

const AddClerk = ({ alertType, title, companyIds, tokens, onClose, user }) => {
  const { tokenurl, companyid } = qs.parse(window.location.search);
  const token = tokens === undefined ? tokenurl : tokens;
  const companyId = companyIds === undefined ? companyid : companyIds;
  console.log(token);
  console.log(companyId);
  //  0  是营业执照扫描件  1 是身份证正面  2 是身份证反面
  let imgType = null;
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 }
  };
  const [industryData, setIndustryData] = useState([]);
  const [form] = Form.useForm();
  const [moreData, setMoreData] = useState({});
  const [files, setFiles] = useState({});
  const [state, setState] = useState({
    loading: false
  });
  const { imageUrl } = state;
  const [state2, setState2] = useState({
    loading: false,
    imageUrl: null
  });
  const [state3, setState3] = useState({
    loading: false,
    imageUrl: null
  });
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  //  解析图片
  const imgBase = (fileName, type) => {
    const finnal =
      (baseUrl || "http://test.qyconsult.treeyee.com") +
      "/fileStorage/downloadFileSecret?fileName=" +
      fileName +
      "&token=" +
      token;
    if (type === 0) {
      setState({ ...state, imageUrl: finnal });
    } else if (type === 1) {
      setState2({ ...state, imageUrl: finnal });
    } else {
      setState3({ ...state, imageUrl: finnal });
    }
  };
  // 获取是否有详情
  const getDataFn = () => {
    console.log("title", title);
    if (title === "企业认证") {
      infoCompanyIdentify({ companyId, token }).then(res => {
        if (res.companyId) {
          // 字符转转数组
          res.location = res.location.split(",");
          res.scope = res.scope.split(",");
          // 图片处理
          imgBase(res.licenseUrl, 0);
          imgBase(res.idcardFront, 1);
          imgBase(res.idcardBack, 2);
          setMoreData(res);
          form.resetFields();
        }
      });
    } else {
      infoCustomerIdentify({ customerId: companyId, token }).then(res => {
        console.log(res);
        if (res.customerId) {
          imgBase(res.idcardFront, 1);
          imgBase(res.idcardBack, 2);
          setMoreData(res);
          form.resetFields();
        }
      });
    }
  };
  function beforeUpload(file) {
    setFiles(file);
    console.log(file);
    // 上传图片的格式为 jpg、jpeg、gif、bmp、png
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/gif" ||
      file.type === "image/bmp";
    if (!isJpgOrPng) {
      message.error("只能上传格式为 jpg、jpeg、gif、bmp、png的图片");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("图片必须小于2MB!");
    }
    return isJpgOrPng && isLt2M;
  }
  const clearImg = (e, type, value) => {
    e.stopPropagation();
    if (type === 0) {
      setState({ ...state, imageUrl: null });
    } else if (type === 1) {
      setState2({ ...state, imageUrl: null });
    } else {
      setState3({ ...state, imageUrl: null });
    }
    form.setFieldsValue({ [value]: null });
  };
  const uploadButton = type => {
    let sp;
    if (type === 0) {
      sp = state.loading;
    } else if (type === 1) {
      sp = state2.loading;
    } else {
      sp = state3.loading;
    }
    return (
      <div>
        {sp ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">上传</div>
      </div>
    );
  };
  const handleChange = info => {
    console.log(info);
    if (info.file.status === "uploading") {
      if (imgType === 0) {
        setState({
          loading: true
        });
      } else if (imgType === 1) {
        setState2({
          loading: true
        });
      } else {
        setState3({
          loading: true
        });
      }

      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, imageUrl => {
        if (imgType === 0) {
          setState({
            imageUrl,
            loading: false
          });
        } else if (imgType === 1) {
          setState2({
            imageUrl,
            loading: false
          });
        } else {
          setState3({
            imageUrl,
            loading: false
          });
        }
      });
    }
  };
  useEffect(() => {
    getDataFn();
    getIndustry().then(data => {
      setIndustryData(data);
    });
    // setState({
    //   imageUrl: moreData.cover,
    //   loading: false
    // });
    // console.log(moreData);
  }, []);
  const onSubmit = values => {
    // 到期时间处理
    console.log(moreData);
    if (values.foundedType === 1) {
      values.founded = moreData.founded;
    }
    //  图片处理
    if (values.licenseUrl) {
      values.licenseUrl = values.licenseUrl.file
        ? values.licenseUrl.file.response
        : values.licenseUrl;
    }
    if (values.idcardFront) {
      values.idcardFront = values.idcardFront.file
        ? values.idcardFront.file.response
        : values.idcardFront;
    }
    if (values.idcardBack) {
      values.idcardBack = values.idcardBack.file
        ? values.idcardBack.file.response
        : values.idcardBack;
    }
    // 数组处理
    if (values.scope) {
      values.scope = values.scope.join(",");
    }
    if (values.location) {
      values.location = values.location.join(",");
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const x in moreData) {
      if (!values[x]) {
        values[x] = moreData[x];
      }
    }
    console.log("onClose", onClose);
    // 有id 走修改  没id走创建
    if (!moreData.identifyId) {
      if (title === "企业认证") {
        values.companyId = companyId;
        createCompanyIdentify(values, token).then(() => {
          showMessage("success", "操作成功！");
          if (onClose) {
            onClose();
          }
        });
      } else {
        values.customerId = companyId;
        createCustomerIdentify(values, token).then(() => {
          showMessage("success", "操作成功！");
          if (onClose) {
            onClose();
          }
        });
      }
    } else if (title === "企业认证") {
      values.companyId = companyId;
      updateCompanyIdentify(values.identifyId, values, token).then(() => {
        if (onClose) {
          user.dispatch({ type: "init" });
          onClose();
        }
        showMessage("success", "操作成功！");
      });
    } else {
      values.customerId = companyId;
      updateCustomerIdentify(values.identifyId, values, token).then(() => {
        if (onClose) {
          user.dispatch({ type: "init" });
          onClose();
        }
        showMessage("success", "操作成功！");
      });
    }
  };

  return (
    <div className="renZhengBox">
      {title === "企业认证" ? (
        <div className="tBox">
          <h3>这是一项身份识别服务，请注意以下几点：</h3>
          <ul>
            <li>
              请确保您是具有法人资格的商户，您需提供可证明您依法设立、依法经营，开展社会活动的执照、证件等（如营业执照副本）
            </li>
            <li>证件有效期在3个月内的商户，请找工商部门更新资料后再行提交</li>
            <li>
              根据《中华人民共和国发票管理办法》相关规定：所有单位和从事生产、经营活动的个人在购买商品、接受服务以及从事其他经营活动支付款项，应当向收款方取得发票。取得发票时，不得要求变更与实际经营情况不符的开票信息。因此为防止虚开，要求开具企业发票需与实名认证的主体作对应，个人实名认证只能开具个人发票。谢谢配合！
            </li>
          </ul>
        </div>
      ) : (
        <div className="tBox">
          <h3>这是一项身份识别服务，请注意以下几点：</h3>
          <ul>
            <li>
              根据《中华人民共和国发票管理办法》相关规定：所有单位和从事生产、经营活动的个人在购买商品、接受服务以及从事其他经营活动支付款项，应当向收款方取得发票。取得发票时，不得要求变更与实际经营情况不符的开票信息。因此为防止虚开，要求开具企业发票需与实名认证的主体作对应，个人实名认证只能开具个人发票。谢谢配合！
            </li>
          </ul>
        </div>
      )}
      {moreData.identify === 1 && (
        <Alert message={`您提交的${title}信息正在审核中~`} type="warning" />
      )}
      {moreData.identify === 2 && (
        <Alert
          message={`您提交的${title}信息审核失败，失败原因：${moreData.history[0].reject}，您可修改信息后重新发起${title}`}
          type="error"
        />
      )}
      {moreData.identify === 3 && (
        <Alert message={`您提交的${title}信息已审核成功`} type="success" />
      )}
      <Form
        {...layout}
        form={form}
        onFinish={onSubmit}
        style={{ marginTop: 20 }}
        initialValues={moreData}
      >
        {title === "企业认证" && (
          <div>
            <h3>填写企业信息</h3>
            <Form.Item
              label="企业名称"
              name="companyName"
              rules={[
                {
                  required: true,
                  message: "请输入企业名称"
                }
              ]}
            >
              <Input
                placeholder="请填写与营业执照上一致的名称"
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="营业执照注册号"
              name="license"
              rules={[
                {
                  required: true,
                  message: "请输入营业执照注册号"
                }
              ]}
            >
              <Input
                placeholder="统一社会信用代码"
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="营业执照所在地"
              name="location"
              rules={[
                {
                  required: true,
                  message: "请选择营业执照所在地"
                }
              ]}
            >
              <Cascader
                options={city}
                placeholder="请选择营业执照所在地"
                fieldNames={{
                  label: "label",
                  value: "label",
                  children: "children"
                }}
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="常用地址"
              name="address"
              rules={[
                {
                  required: true,
                  message: "请输入常用地址"
                }
              ]}
            >
              <Input
                placeholder="请输入常用地址"
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="营业期限"
              name="foundedType"
              rules={[
                {
                  required: true,
                  message: "请选择营业期限"
                }
              ]}
            >
              <Radio.Group>
                <Radio
                  value={1}
                  disabled={
                    !!(moreData.identify === 1 || moreData.identify === 3)
                  }
                >
                  <DatePicker
                    value={moment(moreData.founded)}
                    onChange={e => {
                      setMoreData({
                        ...moreData,
                        founded: new Date(e).getTime()
                      });
                      form.setFieldsValue({ foundedType: 1 });
                    }}
                    disabled={
                      !!(moreData.identify === 1 || moreData.identify === 3)
                    }
                  />
                </Radio>
                <Radio
                  value={2}
                  disabled={
                    !!(moreData.identify === 1 || moreData.identify === 3)
                  }
                >
                  长期
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="经营范围"
              name="scope"
              rules={[
                {
                  required: true,
                  message: "请选择经营范围"
                }
              ]}
            >
              <Cascader
                options={industryData}
                placeholder="请选择经营范围"
                fieldNames={{
                  label: "label",
                  value: "label",
                  children: "children"
                }}
              />
            </Form.Item>
            <Form.Item
              label="营业执照扫描件"
              name="licenseUrl"
              rules={[
                {
                  required: true,
                  message: "请上传营业执照扫描件"
                }
              ]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${baseUrl}/fileStorage/uploadFileSecret`}
                data={{ token, file: files }}
                disabled={alertType === 1}
                beforeUpload={beforeUpload}
                onChange={e => {
                  imgType = 0;
                  handleChange(e);
                }}
              >
                {imageUrl ? (
                  <div className="xfCloseBox">
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                    {moreData.identify === 1 || moreData.identify === 3
                      ? ""
                      : alertType !== 1 && (
                      <a
                            href="JavaScript:;"
                            title="清除图片"
                            onClick={e => clearImg(e, 0, "licenseUrl")}
                          >
                            <CloseCircleOutlined />
                          </a>
                        )}
                  </div>
                ) : (
                  uploadButton(0)
                )}
              </Upload>
            </Form.Item>
            <div className="rezyao">
              <h4>证件要求：</h4>
              <ul>
                <li>
                  请上传由中国大陆工商局办法的，在有效期内且年检章齐全（当年成立的公司可无年检章）的证件图片
                </li>
                <li>
                  请提供清晰、完整的<span className="red">彩色</span>
                  原件扫描件或数码照
                </li>
                <li>
                  证件必须是<span className="red">彩色</span>
                  原件电子版，可以是扫描件或者数码拍摄照片
                </li>
                <li>仅支持.jpg .bmp .png .gif的图片格式，图片大小不超过4M</li>
              </ul>
            </div>
            {/* <h3>填写法人信息</h3>
            <Form.Item
              label="法人姓名"
              name="juridical"
              rules={[
                {
                  required: true,
                  message: "请输入法人姓名"
                }
              ]}
            >
              <Input placeholder="请填写与身份证号上一致的姓名" />
            </Form.Item>
            <Form.Item
              label="身份证号"
              name="idcard"
              rules={[
                {
                  required: true,
                  message: "请输入身份证号"
                }
              ]}
            >
              <Input placeholder="请输入身份证号" />
            </Form.Item>
            <Form.Item
              label="身份证人像面照"
              name="idcardFront"
              rules={[
                {
                  required: true,
                  message: "请上传营业执照扫描件"
                }
              ]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${baseUrl}/fileStorage/uploadFileSecret`}
                data={{ token, file: files }}
                disabled={alertType === 1}
                beforeUpload={beforeUpload}
                onChange={e => {
                  imgType = 1;
                  handleChange(e);
                }}
              >
                {state2.imageUrl ? (
                  <div className="xfCloseBox">
                    <img
                      src={state2.imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                    {alertType !== 1 && (
                      <a
                        href="JavaScript:;"
                        title="清除图片"
                        onClick={e => clearImg(e, 1, "idcardFront")}
                      >
                        <CloseCircleOutlined />
                      </a>
                    )}
                  </div>
                ) : (
                  uploadButton(1)
                )}
              </Upload>
            </Form.Item>
            <div className="rezyao rezyao2">
              <h4>证件要求：</h4>
              <img src="/img/idCard1.png" alt="示例图片" />
              <ul>
                <li>请上传本人身份证人像面头部照片</li>
                <li>必须看清证件信息，且证件信息不能被遮挡</li>
                <li>仅支持.jpg .bmp .png .gif的图片格式</li>
                <li>图片大小不超过4M，长宽4096px以内</li>
                <li>您提供的照片我们将予以保护，不会用于其他用途</li>
              </ul>
            </div>
            <Form.Item
              label="身份证国徽面照"
              name="idcardBack"
              rules={[
                {
                  required: true,
                  message: "请上传身份证国徽面照"
                }
              ]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${baseUrl}/fileStorage/uploadFileSecret`}
                data={{ token, file: files }}
                disabled={alertType === 1}
                beforeUpload={beforeUpload}
                onChange={e => {
                  imgType = 2;
                  handleChange(e);
                }}
              >
                {state3.imageUrl ? (
                  <div className="xfCloseBox">
                    <img
                      src={state3.imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                    {alertType !== 1 && (
                      <a
                        href="JavaScript:;"
                        title="清除图片"
                        onClick={e => clearImg(e, 2, "idcardBack")}
                      >
                        <CloseCircleOutlined />
                      </a>
                    )}
                  </div>
                ) : (
                  uploadButton(2)
                )}
              </Upload>
            </Form.Item>
            <div className="rezyao rezyao2">
              <h4>证件要求：</h4>
              <img src="/img/idCard2.png" alt="示例图片" />
              <ul>
                <li>必须看清证件信息，且证件信息不能被遮挡</li>
                <li>仅支持.jpg .bmp .png .gif的图片格式</li>
                <li>图片大小不超过4M，长宽4096px以内</li>
                <li>您提供的照片我们将予以保护，不会用于其他用途</li>
              </ul>
            </div> */}
          </div>
        )}

        {title === "个人认证" && (
          <div>
            <h3>填写个人信息</h3>
            <Form.Item
              label="个人姓名"
              name="customerName"
              rules={[
                {
                  required: true,
                  message: "请输入个人姓名"
                }
              ]}
            >
              <Input
                placeholder="请填写与身份证号上一致的姓名"
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="身份证号"
              name="idcard"
              rules={[
                {
                  required: true,
                  message: "请输入身份证号"
                }
              ]}
            >
              <Input
                placeholder="请输入身份证号"
                disabled={
                  !!(moreData.identify === 1 || moreData.identify === 3)
                }
              />
            </Form.Item>
            <Form.Item
              label="身份证人像面照"
              name="idcardFront"
              rules={[
                {
                  required: true,
                  message: "请上传营业执照扫描件"
                }
              ]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${baseUrl}/fileStorage/uploadFileSecret`}
                data={{ token, file: files }}
                disabled={alertType === 1}
                beforeUpload={beforeUpload}
                onChange={e => {
                  imgType = 1;
                  handleChange(e);
                }}
              >
                {state2.imageUrl ? (
                  <div className="xfCloseBox">
                    <img
                      src={state2.imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                    {moreData.identify === 1 || moreData.identify === 3
                      ? ""
                      : alertType !== 1 && (
                          <a
                        href="JavaScript:;"
                        title="清除图片"
                        onClick={e => clearImg(e, 1, "idcardFront")}
                          >
                        <CloseCircleOutlined />
                      </a>
                        )}
                  </div>
                ) : (
                  uploadButton(1)
                )}
              </Upload>
            </Form.Item>
            <div className="rezyao rezyao2">
              <h4>证件要求：</h4>
              <img src="/img/idCard1.png" alt="示例图片" />
              <ul>
                <li>请上传本人身份证人像面头部照片</li>
                <li>必须看清证件信息，且证件信息不能被遮挡</li>
                <li>仅支持.jpg .bmp .png .gif的图片格式</li>
                <li>图片大小不超过4M，长宽4096px以内</li>
                <li>您提供的照片我们将予以保护，不会用于其他用途</li>
              </ul>
            </div>
            <Form.Item
              label="身份证国徽面照"
              name="idcardBack"
              rules={[
                {
                  required: true,
                  message: "请上传身份证国徽面照"
                }
              ]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${baseUrl}/fileStorage/uploadFileSecret`}
                data={{ token, file: files }}
                disabled={alertType === 1}
                beforeUpload={beforeUpload}
                onChange={e => {
                  imgType = 2;
                  handleChange(e);
                }}
              >
                {state3.imageUrl ? (
                  <div className="xfCloseBox">
                    <img
                      src={state3.imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                    {moreData.identify === 1 || moreData.identify === 3
                      ? ""
                      : alertType !== 1 && (
                          <a
                        href="JavaScript:;"
                        title="清除图片"
                        onClick={e => clearImg(e, 2, "idcardBack")}
                      >
                        <CloseCircleOutlined />
                      </a>
                        )}
                  </div>
                ) : (
                  uploadButton(2)
                )}
              </Upload>
            </Form.Item>
            <div className="rezyao rezyao2">
              <h4>证件要求：</h4>
              <img src="/img/idCard2.png" alt="示例图片" />
              <ul>
                <li>必须看清证件信息，且证件信息不能被遮挡</li>
                <li>仅支持.jpg .bmp .png .gif的图片格式</li>
                <li>图片大小不超过4M，长宽4096px以内</li>
                <li>您提供的照片我们将予以保护，不会用于其他用途</li>
              </ul>
            </div>
          </div>
        )}
        <div className="btnbox">
          <Button
            type="primary"
            htmlType="submit"
            disabled={!!(moreData.identify === 1 || moreData.identify === 3)}
          >
            提交认证
          </Button>
          <p style={{ marginTop: 20 }}>
            我们将在2个工作日内审核您提交的认证信息
          </p>
        </div>
      </Form>
    </div>
  );
};

export default AddClerk;
